module.exports = __webpack_public_path__ + "img/hswt.25afb63f.png";